export default __webpack_public_path__ + "static/media/classroom.566ae0eb.jpeg";